export class FocusUtil {

  static focusFirstInvalidFormControl(form: ParentNode): void {
    const firstInvalidControl = form.querySelector<HTMLElement>(
      'input.ng-invalid:not([type="hidden"]):not([disabled]), textarea.ng-invalid:not([disabled]), select.ng-invalid:not([disabled]), mat-select.ng-invalid'
    );

    if (firstInvalidControl) {
      firstInvalidControl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      firstInvalidControl.focus();
    }
  }
}


